/* Firebase Auth handle + email/password helpers. Owner accounts are
   created in the Firebase console (or via scripts/add-admin.mjs) and
   allow-listed by an admins/{uid} doc — enforced in security rules,
   surfaced in the UI by AuthContext. */
import {
  getAuth,
  signInWithEmailAndPassword,
  signOut as fbSignOut,
  sendPasswordResetEmail,
  onAuthStateChanged,
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword,
} from 'firebase/auth'
import { app } from './firebase.js'

export const auth = getAuth(app)

export const signIn = (email, password) => signInWithEmailAndPassword(auth, email, password)
export const signOut = () => fbSignOut(auth)
export const resetPassword = (email) => sendPasswordResetEmail(auth, email)
export const watchAuth = (cb) => onAuthStateChanged(auth, cb)

// Change the signed-in user's password. Re-authenticates with the current
// password first (Firebase requires a recent login for updatePassword), so it
// works regardless of session age.
export async function changePassword(currentPassword, newPassword) {
  const user = auth.currentUser
  if (!user || !user.email) throw new Error('Not signed in.')
  const cred = EmailAuthProvider.credential(user.email, currentPassword)
  await reauthenticateWithCredential(user, cred)
  await updatePassword(user, newPassword)
}
